import styled from 'styled-components';
import { colors, typography, spacing } from '../../design-system';



export const SettingsTable = styled.div`
  background: ${colors.background.primary};
  border-radius: 12px;
  border: 1px solid ${colors.border.primary};
  overflow: hidden;
`;

export const SettingsRow = styled.div`
  display: flex;
  align-items: center;
  padding: ${spacing[5]} ${spacing[6]};
  border-bottom: 1px solid ${colors.border.secondary};
  transition: background-color 0.15s ease;
  
  &:last-child {
    border-bottom: none;
  }
  
  &:hover {
    background: ${colors.background.hover};
  }
`;

export const SettingIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background: ${colors.background.secondary};
  color: ${colors.text.secondary};
  margin-right: ${spacing[4]};
  flex-shrink: 0;
`;

export const SettingContent = styled.div`
  flex: 1;
  min-width: 0;
`;

export const SettingName = styled.div`
  font-size: ${typography.fontSizes.sm};
  font-weight: 500;
  color: ${colors.text.primary};
  margin-bottom: 2px;
`;

export const SettingDescription = styled.div`
  font-size: ${typography.fontSizes.xs};
  color: ${colors.text.secondary};
  line-height: 1.4;
`;

export const SettingStatus = styled.div<{ statusType: 'success' | 'warning' | 'error' | 'neutral' }>`
  font-size: ${typography.fontSizes.xs};
  font-weight: 500;
  margin-right: ${spacing[4]};
  white-space: nowrap;
  
  ${props => {
    switch (props.statusType) {
      case 'success':
        return `
          color: ${colors.feedback.success.text};
        `;
      case 'warning':
        return `
          color: ${colors.feedback.warning.text};
        `;
      case 'error':
        return `
          color: ${colors.feedback.error.text};
        `;
      default:
        return `
          color: ${colors.text.secondary};
        `;
    }
  }}
`;

export const SettingActions = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

 